const randString = (targetLenght = 32) => {
  const stringCollection =  "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456780-";
  const stringLength = stringCollection.length;
  return Array(targetLenght).fill(1).reduce((acc)=>{
    return acc+= stringCollection.charAt(Math.floor(Math.random() * stringLength))
  },'')
}

export default randString


// WEBPACK FOOTER //
// ./src/misc/hash.js